import React from "react";
// import { Navigate } from "react-router-dom";


import Home from "../pages/home";
import AboutUs from "../pages/aboutus";
import People from "../pages/people";
import Publications from "../pages/publications";
import Resources from "../pages/resources";
import News from "../pages/news"; 
import Events from "../pages/events";
import Milestone from "../pages/aboutus/milestone";
import Malaria from "../pages/diseases/malaria";
import Tuberculosis from "../pages/diseases/tuberculosis";
import EventDetail from "../pages/events/event-detail";
import Measles from "../pages/diseases/measles";
import NeglectedTropicalDiseases from "../pages/diseases/neglected-tropical-diseases";
import ContactUs from "../pages/contactus";
import Sitemap from "../pages/sitemap";
import JoinUs from "../pages/joinus/joinus";
import Blog from "../pages/blog";
import BlogDetails from "../pages/blog/details"; 
import PageNotFound from "../pages/notFound/notFound";
import Search from "../pages/layout/searchresults";
import ErrorPage from "../pages/layout/errorPage";
import Newsletter from "../pages/newsletter/newsletter";

const websiteRoutes = [
    { path: "/", component: <Home /> },
    { path: "/home", component: <Home /> },
    { path: "/aboutus", component: <AboutUs /> },
    { path: "/milestone", component: <Milestone /> },
    { path: "/people/:pcategory_pagename", component: <People /> },
    { path: "/disease/:disease_pagename", component: <Malaria /> },
    { path: "/publications", component: <Publications /> },
    { path: "/resources", component: <Resources /> },
    { path: "/news", component: <News /> },

    { path: "/blog", component: <Blog /> },
    { path: "/blog/:blog_year", component: <Blog /> },
    { path: "/blog-category/:blog_category_pagename", component: <Blog /> },
    { path: "/blog-authors/:blog_author_pagename", component: <Blog /> },
    { path: "/blog-tags/:blog_tags_pagename", component: <Blog /> },
    { path: "/blog-search/:blog_search", component: <Blog /> },
    { path: "/blog-details/:blog_pagename", component: <BlogDetails /> },

    { path: "/events", component: <Events /> },
    { path: "/events-detail/:event_pagename", component: <EventDetail /> },
    { path: "/contactus", component: <ContactUs /> },
    { path: "/sitemap", component: <Sitemap /> },
    { path: "/joinus", component: <JoinUs /> },

    { path: "/newsletter/:nletter_year", component: <Newsletter /> },

    { path: "/search-results/:str", component: <Search/> },

    { path: '/error-page' , component: <ErrorPage/> },
    { path: '*' , component: <PageNotFound/> }
];

export { websiteRoutes };